import * as React from 'react'
import { FormGroup, Col, Row, Modal } from 'react-bootstrap'

interface LoadIndicatorProps {
	message?: string
	type?: 'inline' | 'overlay'
}

const LoadIndicator: React.SFC<LoadIndicatorProps> = (props) => {
	switch (props.type) {
		case 'overlay':
			return (
				<Modal show={true} onHide={hide}>
					<Modal.Body className="text-center" style={modalStyle}>
						<Row>{getRandomSentence(loadSentences)}</Row>
						<Row style={loadingRowStyle}>
							<span style={loadingTextStyle}>LOADING</span>
							<i data-testid="loadingIndicator" style={spinnerStyle} className="fa fa-spinner fa-spin fa-2x" />
						</Row>
					</Modal.Body>
				</Modal>
			)

		case 'inline':
		default:
			return (
				<FormGroup controlId="spinner">
					<Col xs={12} className="text-center" style={{ margin: '20px' }}>
						<i data-testid="loadingIndicator" className="fa fa-spinner fa-spin fa-2x text-danger" /> {props.message}
					</Col>
				</FormGroup>
			)
	}
}

const loadingRowStyle = {
	fontSize: '18px',
	marginTop: '20px',
}
const loadingTextStyle = {
	marginRight: '15px',
	verticalAlign: 'middle',
}
const modalStyle = {
	marginTop: '20px',
	marginBottom: '10px',
}
const spinnerStyle = {
	verticalAlign: 'middle',
}
const hide = () => {
	return
}

const getRandomSentence = (sentences: string[]) => {
	return sentences[getRandomIntBetweenNumbers(0, sentences.length)]
}

const getRandomIntBetweenNumbers = (min: number, max: number) => {
	return Math.floor(Math.random() * (max - min)) + min
}

const loadSentences = [
	'Please wait, spinning up the hamster.',
	'Please wait, shovelling coal into the server.',
	'Please wait, the architects are still drafting.',
	'Please wait, the bits are breeding.',
	"Please wait, we're building the buildings as fast as we can.",
	'Please wait, would you prefer chicken, steak, or tofu?',
	'Please wait, pay no attention to the man behind the curtain.',
	'Please wait and enjoy the elevator music.',
	'Please wait, while the little elves draw your map.',
	'Please wait, a few bits tried to escape, but we caught them.',
	'Please wait and dream of faster computers.',
	'Please wait, would you like fries with that?',
	'Please wait, checking the gravitational constant in your locale.',
	'Please wait, go ahead -- hold your breath.',
	"Please wait, at least you're not on hold.",
	'Please wait, hum something loud while others stare.',
	'Please wait, the server is powered by a lemon and two electrodes.',
	'Please wait, we love you just the way you are.',
	"Please wait, we're testing your patience.",
	'Please wait, as if you had any other choice.',
	'Please wait, take a moment to sign up for our lovely prizes.',
	"Please wait, don't think of purple hippos.",
	'Please wait, follow the white rabbit.',
	"Please wait, why don't you order a sandwich?",
	'Please wait, while the satellite moves into position.',
	'Please wait, the bits are flowing slowly today.',
]

export default LoadIndicator
